/* eslint-disable indent */
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { DefaultTable } from 'src/components';
import { IW2Form } from 'src/interfaces';
import paymentsService from 'src/services/payments.service';

const customStyles = {
  headRow: {
    style: {
      border: 'none',
    },
  },
  headCells: {
    style: {
      color: '#9399B2',
      font: 'normal normal bold 16px Biotif',
    },
  },
  rows: {
    style: {
      font: 'normal normal normal 14px Biotif',
      color: '#1B1D35',
      borderRadius: '5px',
      '&:not(:last-of-type)': {
        borderBottomWidth: '0px',
      },
    },
    stripedStyle: {
      color: '#1B1D35',
      backgroundColor: '#F3F4F8',
    },
    highlightOnHoverStyle: {
      backgroundColor: 'rgb(230, 244, 244)',
      borderBottomColor: '#FFFFFF',
      borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
  },
  cells: {
    style: {
      '&:last-of-type': {
        justifyContent: 'center',
      },
    },
  },
  pagination: {
    style: {
      border: 'none',
      svg: {
        fill: 'rgba(0,0,0,0.54)',
      },
    },
  },
};

const columns = [
  // {
  //   name: 'Control Number',
  //   selector: (row: IW2Form) => row.controlNumber,
  // },
  {
    name: 'Form Issued',
    selector: (row: IW2Form) => row.year,
  },
  {
    name: 'Form Uploaded',
    selector: (row: IW2Form) => row.year,
  },
  {
    name: 'Form Name',
    selector: (row: IW2Form) => row.name,
  },
  {
    name: 'Link',
    button: true,
    cell: (row: IW2Form) => (
      <a
        href={
          row.name === 'W2-FORM'
            ? paymentsService.getW2FormPdf(row.controlNumber, row.year, row.identificationNumber, row.employeeId, true)
            : paymentsService.getHealthFormPdf(
                row.controlNumber,
                row.year,
                row.identificationNumber,
                row.employeeId,
                true
              )
        }
        target="_blank"
        rel="noopener noreferrer"
      >
        Download
      </a>
    ),
  },
];

const TaxFormsTable: React.FC = () => {
  const { isLoading, data: w2List } = useQuery({
    queryKey: ['tax-forms'],
    queryFn: paymentsService.getW2List,
    enabled: true,
  });

  return <DefaultTable progressPending={isLoading} columns={columns} data={w2List ?? []} customStyles={customStyles} />;
};

export default TaxFormsTable;
